import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; 
import { FaBars, FaTimes } from 'react-icons/fa'; 

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">CricketLive</Link>
      </div>
      <div className="navbar-icon" onClick={toggleMenu}>
        {isMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
        <li>
          <Link to="/" onClick={toggleMenu}>Home</Link>
        </li>
        <li>
          <Link to="/upcoming-matches" onClick={toggleMenu}>Upcoming Matches</Link>
        </li>
        <li>
          <Link to="/about" onClick={toggleMenu}>About</Link>
        </li>
        <li>
          <Link to="/contact" onClick={toggleMenu}>Contact</Link>
        </li>
        <li>
          <Link to="https://www.quickdials.in/" target="_blank" onClick={toggleMenu}> Business Free Listing </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
